import React from "react";

const ReviewsSection = () => {
  const reviews = [
    { name: "Amelia W", text: "❤️ and that is all" },
    { name: "Paul P", text: "Thanks Chris!! See u soon." },
    { name: "Didi F", text: "George is 💕" },
  ];

  return (
    <>
      <h2 className="text-3xl font-bold mb-6">Reviews</h2>
      <div className="space-y-4">
        {reviews.map((review, idx) => (
          <div
            key={idx}
            className="border-l-4 border-blue-500 pl-4 py-2 bg-border"
          >
            <p className="font-semibold">{review.name}</p>
            <p className="text-sm">{review.text}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default ReviewsSection;
